import React from 'react';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';
import cn from 'classnames';

import { MODALS } from '~redux/Modal/constants';
import ModalActions from '~redux/Modal/actions';

import ErrorModal from '../ErrorModal';

import { getButtons } from './utils';
import styles from './styles.module.scss';

const NoRidersModal = () => {
  const dispatch = useDispatch();
  const closeModal = () => dispatch(ModalActions.closeModal(MODALS.NO_RIDERS));
  const openDispatchMethodModal = () => {
    closeModal();
    dispatch(ModalActions.openModal(MODALS.DELIVERY_OR_PICKUP));
  };
  return (
    <ErrorModal modalName={MODALS.NO_RIDERS} buttons={getButtons(closeModal, openDispatchMethodModal)}>
      <div className={cn(styles.textContainer, 'column space-around center')}>
        {i18next.t('NoRiders:sorry')}
        <div className={styles.continue}>{i18next.t('NoRiders:continue')}</div>
      </div>
    </ErrorModal>
  );
};

export default NoRidersModal;
